import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { tasks as tasksApi } from 'redux/modules/api'
import { combineAnd } from 'utils/apiFilter'

function decorator (config = {}) {
  return ComposedComponent => {
    @connect(
      ({ api, auth, app }) => ({
        tasksAjEvents: api.tasks.aj,
        user: auth.user,
        commonLimit: app.commonLimit
      }),
      { ...tasksApi.aj }
    )
    class TasksAj extends Component {
      static propTypes = {
        tasksAjEvents: PropTypes.object.isRequired,
        decoFilterMyOnly: PropTypes.bool,
        getTasksAjEvents: PropTypes.func.isRequired,
        getTasksAjParticipantEvents: PropTypes.func.isRequired,
        getTasksAjPreparationAndTraining: PropTypes.func.isRequired,
        user: PropTypes.object,
        commonLimit: PropTypes.number,
        setTasksAjParticipantEventsParams: PropTypes.func,
        setTasksAjEventsParams: PropTypes.func,
        setTasksAjPrepParams: PropTypes.func
      }

      componentDidMount () {
        const {
          decoFilterMyOnly,
          commonLimit,
          tasksAjEvents,
          setTasksAjParticipantEventsParams,
          setTasksAjEventsParams,
          setTasksAjPrepParams
        } = this.props

        if (config.useCommonLimit && commonLimit) {
          const newParams = { limit: commonLimit }

          config.tasks && setTasksAjParticipantEventsParams(newParams)
          config.events && setTasksAjEventsParams(newParams)
          config.preparation && setTasksAjPrepParams(newParams)
        } else {
          config.tasks &&
            this.handleGetTasksAjParticipantEvents(tasksAjEvents, decoFilterMyOnly)
          config.events &&
            this.handleGetTasksAjEvents(tasksAjEvents, decoFilterMyOnly)
          config.preparation &&
            this.handleGetTasksPreparationTraining(tasksAjEvents, decoFilterMyOnly)
        }
      }

      componentWillReceiveProps (nextProps) {
        const { tasksAjEvents, decoFilterMyOnly } = this.props
        const { filter, limit, offset, sort, invalidate } = nextProps.tasksAjEvents
        const prepAndTrain = nextProps.tasksAjEvents.preparationAndTraining
        const oldPrepAndTrain = this.props.tasksAjEvents.preparationAndTraining
        const pEvents = nextProps.tasksAjEvents.participantEvents
        const oldPEvents = this.props.tasksAjEvents.participantEvents

        if (
          tasksAjEvents.filter !== filter ||
          tasksAjEvents.limit !== limit ||
          tasksAjEvents.offset !== offset ||
          tasksAjEvents.sort !== sort ||
          tasksAjEvents.invalidate !== invalidate
        ) {
          config.tasks &&
          this.handleGetTasksAjParticipantEvents(nextProps.tasksAjEvents, decoFilterMyOnly)
        }

        if (
          config.events &&
          (tasksAjEvents.events.filter !==
            nextProps.tasksAjEvents.events.filter ||
            tasksAjEvents.events.limit !==
            nextProps.tasksAjEvents.events.limit ||
            tasksAjEvents.events.offset !==
            nextProps.tasksAjEvents.events.offset ||
            tasksAjEvents.events.sort !== nextProps.tasksAjEvents.events.sort ||
            tasksAjEvents.events.invalidate !== nextProps.tasksAjEvents.events.invalidate ||
            decoFilterMyOnly !== nextProps.decoFilterMyOnly
          )
        ) {
          this.handleGetTasksAjEvents(nextProps.tasksAjEvents.events, nextProps.decoFilterMyOnly)
        }

        if (
          oldPrepAndTrain.filter !== prepAndTrain.filter ||
          oldPrepAndTrain.limit !== prepAndTrain.limit ||
          oldPrepAndTrain.offset !== prepAndTrain.offset ||
          oldPrepAndTrain.sort !== prepAndTrain.sort ||
          oldPrepAndTrain.invalidate !== prepAndTrain.invalidate ||
          decoFilterMyOnly !== nextProps.decoFilterMyOnly
        ) {
          this.handleGetTasksPreparationTraining(prepAndTrain, nextProps.decoFilterMyOnly)
        }

        if (
          oldPEvents.filter !== pEvents.filter ||
          oldPEvents.limit !== pEvents.limit ||
          oldPEvents.offset !== pEvents.offset ||
          oldPEvents.sort !== pEvents.sort ||
          oldPEvents.invalidate !== pEvents.invalidate ||
          decoFilterMyOnly !== nextProps.decoFilterMyOnly
        ) {
          this.handleGetTasksAjParticipantEvents(pEvents, nextProps.decoFilterMyOnly)
        }
      }

      handleGetTasksAjParticipantEvents = (tasks, myOnly) => {
        const personId = this.props.user.personId
        const filterMyOnly = myOnly || this.props.decoFilterMyOnly
        const combinedFilter = combineAnd(tasks.filter,
          filterMyOnly
            ? `award.awardLeader.person.id=${personId}`
            : '')

        return this.props.getTasksAjParticipantEvents({ ...tasks, filter: combinedFilter })
      }

      handleGetTasksAjEvents = (tasks, decoFilterMyOnly) => {
        const personId = this.props.user.personId
        const filter = combineAnd(decoFilterMyOnly
          ? `ajEvent.award.awardLeader.person.id=${personId}`
          : '')

        return this.props.getTasksAjEvents(tasks, filter)
      }

      handleGetTasksPreparationTraining = (tasks, myOnly) => {
        const personId = this.props.user.personId
        const filterMyOnly = myOnly || this.props.decoFilterMyOnly
        const combinedFilter = combineAnd(tasks.filter,
          filterMyOnly
            ? `award.awardLeader.person.id=${personId}`
            : '')

        return this.props.getTasksAjPreparationAndTraining({ ...tasks, filter: combinedFilter })
      }

      render () {
        return <ComposedComponent {...this.props} />
      }
    }

    return TasksAj
  }
}

export default decorator
